/* eslint-disable vue/no-mutating-props */
<template>
  <template v-if="['edit', 'form_edit'].includes(mode)">
    <SingleLineField
      v-if="['single_line', 'phone', 'zipcode', 'currency'].includes(field.field_id)"
      :field="field"
      @update="update"
      :mode="mode"
      :ref="field.name"
    ></SingleLineField>

    <DateField
      v-if="field.field_id === 'date'"
      :field="field"
      @update="update"
      :mode="mode"
      :ref="field.name"
    ></DateField>

    <SsnField
      v-if="field.field_id === 'ssn'"
      :field="field"
      @update="update"
      :mode="mode"
      :ref="field.name"
    ></SsnField>

    <StateField
      v-if="field.field_id === 'state'"
      :field="field"
      @update="update"
      :mode="mode"
      :ref="field.name"
    ></StateField>

    <EmailField
      v-if="field.field_id === 'email'"
      :field="field"
      @update="update"
      :mode="mode"
      :ref="field.name"
    ></EmailField>

    <MultiLineField
      v-if="field.field_id === 'multi_line'"
      :field="field"
      @update="update"
      :mode="mode"
      :ref="field.name"
    ></MultiLineField>

    <UnitField
      v-if="field.field_id === 'unit_field'"
      :field="field"
      @update="update"
      :mode="mode"
      :ref="field.name"
    ></UnitField>

    <AddressField
      v-if="field.field_id === 'address'"
      :field="field"
      @update="update"
      @validated="validatedAddress"
      :mode="mode"
      :ref="field.name"
    />

    <TextDisplayField
      v-if="field.field_id === 'text_display'"
      :field="field"
      :mode="mode"
      :ref="field.name"
    ></TextDisplayField>

    <CheckBoxField
      v-if="field.field_id === 'checkbox'"
      :field="field"
      @update="update"
      :mode="mode"
      :ref="field.name"
    ></CheckBoxField>

    <RadioField
      v-if="field.field_id === 'choice'"
      :field="field"
      @update="update"
      :mode="mode"
      :ref="field.name"
    ></RadioField>

    <AttachmentField
      v-if="field.field_id === 'file'"
      :field="field"
      @update="update"
      :mode="mode"
      :ref="field.name"
    ></AttachmentField>

    <SignatureField
      v-if="['signature', 'signature_new'].includes(field.field_id)"
      :field="field"
      @update="update"
      :mode="mode"
      :ref="field.name"
    ></SignatureField>

    <AgentField
      v-if="field.field_id === 'agent'"
      :field="field"
      @update="update"
      :mode="mode"
      :ref="field.name"
    ></AgentField>

    <DropdownField
      v-if="field.field_id === 'dropdown'"
      :field="field"
      @update="update"
      :mode="mode"
      :ref="field.name"
    />

    <DateRangeField
      v-if="field.field_id === 'date_range'"
      :field="field"
      @update="update"
      :mode="mode"
      :ref="field.name"
    />

    <YesOrNoField
      v-if="field.field_id === 'yes_no'"
      :field="field"
      @update="update"
      :mode="mode"
      :ref="field.name"
    />
  </template>
  <template v-else-if="mode === 'view'">
    <template v-if="field.field_id === 'text_display'">
      <div class="flex items-center py-1 px-1">
        <p class="whitespace-pre-line" v-html="field.label"></p>
      </div>
    </template>

    <template v-else-if="['signature', 'signature_new'].includes(field.field_id)">
      <div class="flex items-center py-1 px-3 w-full">
        <SignatureField :field="field" mode="view" />
      </div>
    </template>

    <AttachmentField v-else-if="field.field_id === 'file'" :field="field" mode="view" />

    <CheckBoxField :field="field" mode="view" v-else-if="field.field_id === 'checkbox'" />

    <SsnField :field="field" mode="view" v-else-if="field.field_id === 'ssn'" />

    <DateField :field="field" mode="view" v-else-if="field.field_id === 'date'" />

    <DateRangeField :field="field" mode="view" v-else-if="field.field_id === 'date_range'" />

    <AddressField :field="field" mode="view" v-else-if="field.field_id === 'address'" />

    <YesOrNoField :field="field" mode="view" v-else-if="field.field_id === 'yes_no'" />

    <DropdownField :field="field" mode="view" v-else-if="field.field_id === 'dropdown'" />

    <template v-else>
      <div class="flex items-center md:w-1/2 py-1 px-1 whitespace-pre-line">
        <p>{{ field.label }}</p>
      </div>
      <div class="flex items-center md:w-1/2 py-1 px-1">
        <p class="font-semibold whitespace-pre-line">
          {{ field.value || "Not entered" }}
        </p>
      </div>
    </template>
  </template>
</template>
<script>
export default {
  props: {
    field: {
      type: Object
    },
    mode: {
      type: String
    },
    nested: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update", "validated_address"],
  computed: {
    isValid() {
      return this.$refs[this.field.name].isValid
    }
  },
  methods: {
    skip(val) {
      this.$emit("skip", val)
    },
    update(val) {
      this.$emit("update", val)
    },
    validatedAddress(val) {
      this.$emit("validated_address", val)
    },
    getFieldRef() {
      return this.$refs[this.field.name]
    },
    validateField() {
      this.$refs[this.field.name].validateField()
    }
  }
}
</script>
